<template>

  <div class="wrapper">

    <v-sidebar activeNavItem="contact"></v-sidebar>

    <div class="main-panel">

      <v-navbar :title="'Contacts'"></v-navbar>

      <form @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card">
                        <div class="card-header">
                          <h4 class="card-title">New Contact</h4>
                        </div>



                        <div class="card-body">
                          <div class="row form">

                            <div class="col-12 col-sm-12">
                              <div class="form-group">
                                <label for="addContact_email">Email</label>
                                <input type="text" id="email" name="email" v-on:keyup="contactLiveSearch()" v-model="email" class="form-control" autocomplete="new-password" v-validate="'required|email'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('email')}">
                                <div id="contactCustomLiveSearch" class="customLiveSearch">
                                  <template v-for="row in contactrows">
                                    <div class="customLiveSearchElement" v-on:click="contactSelected(row)">{{ row.email + " (" + row.name + ")" }}</div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="addContact_name">Name</label>
                                <input type="text" disabled="true" id="name" name="name" v-model="name" class="form-control" v-validate="'required|min:2'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('name') }">
                              </div>
                            </div>

                           <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Office</label>
                                <input type="text" id="phoneoffice" name="phoneoffice" v-model="phoneoffice" class="form-control" disabled="true">
                              </div>
                            </div>

                           <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Cell</label>
                                <input type="text" id="phonecell" name="phonecell" v-model="phonecell" class="form-control" disabled="true">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Fax</label>
                                <input type="text" id="fax" name="fax" v-model="fax" class="form-control" disabled="true">
                              </div>
                            </div>


                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Position Description</label>
                                <input type="text" id="position" name="position" v-model="position" class="form-control" disabled="true">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">

                              </div>
                            </div>


                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="company">Company</label>
                                <input type="text" id="company" name="company" v-on:keyup="companyLiveSearch()" autocomplete="new-password" v-model="company" class="form-control" disabled="true">
                                <div id="companyLiveSearch" class="customLiveSearch">
                                  <template v-for="row in companyrows">
                                    <div class="customLiveSearchElement" v-on:click="companySelected(row)">{{ row.display }}</div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="division">Division</label>
                                <input type="text" id="division" name="divison" v-model="division" v-on:keyup="divisionChange()" class="form-control" disabled="true">
                              </div>
                            </div>


                            <div class="col-12">
                              <div class="form-group">
                                <label for="address">Address</label>
                                <input type="text" disabled id="contactAddAddressAutoComplete" name="address" v-validate="'required'" class="form-control" onfocus="this.setAttribute('autocomplete', 'new-password');">
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="form-group">
                                <LeafletMap v-if="hasAddressLocation" height="200px" :starting-center="mapCenter" :points="addressMapPoint" />
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="address">Street Address</label>
                                <input type="text" disabled="true" id="address" name="address" v-model="address" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="city">City</label>
                                <input type="text" disabled="true" id="city" name="city" v-model="city" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="province">State / Province</label>

                                <select id="province" class="form-control" name="province" v-model="province" v-on:change="onProvinceChange(province)" style="-webkit-appearance: none; -webkit-border-radius: 0px;" disabled="true">
                                  <option value="">Select One</option>
                                  <optgroup label="Canadian Provinces">
                                    <option value="AB">Alberta</option>
                                    <option value="BC">British Columbia</option>
                                    <option value="MB">Manitoba</option>
                                    <option value="NB">New Brunswick</option>
                                    <option value="NF">Newfoundland and Labrador</option>
                                    <option value="NT">Northwest Territories</option>
                                    <option value="NS">Nova Scotia</option>
                                    <option value="NU">Nunavut</option>
                                    <option value="ON">Ontario</option>
                                    <option value="PE">Prince Edward Island</option>
                                    <option value="QC">Quebec</option>
                                    <option value="SK">Saskatchewan</option>
                                    <option value="YT">Yukon Territory</option>
                                  </optgroup>
                                  <optgroup label="U.S. States/Territories">
                                    <option value="AK">Alaska</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DC">District of Columbia</option>
                                    <option value="DE">Delaware</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="IA">Iowa</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MD">Maryland</option>
                                    <option value="ME">Maine</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MT">Montana</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NY">New York</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="PR">Puerto Rico</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VA">Virginia</option>
                                    <option value="VT">Vermont</option>
                                    <option value="WA">Washington</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WY">Wyoming</option>
                                  </optgroup>
                                </select>
                              </div>

                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="postal">Postal / Zip</label>
                                <input type="text" disabled="true" id="postal" name="postal" v-model="postal" class="form-control">
                              </div>

                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="country">Country</label>
                                <select id="country" disabled="true" class="form-control" v-model="country" style="-webkit-appearance: none; -webkit-border-radius: 0px;">
                                  <option>Canada</option>
                                  <option>United States</option>
                                </select>
                              </div>
                            </div>



                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Number</label>
                                <input type="text" disabled="true" id="phone" name="phone" v-model="phone" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="website">Website</label>
                                <input type="text" disabled="true" id="website" name="website" v-model="website" class="form-control">
                              </div>
                            </div>


                          </div>
                        </div>

                        
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">

                  <div class="app-error">{{ errorMessage }}</div>
                  <p v-show="validate && errors.has('name')" class="help is-danger">{{ errors.first('name') }}</p>
                  <p v-show="validate && errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
                  <p v-show="validate && !hasCoordinates" class="help is-danger">Could not find address coordinates. The address field is required.</p>

                  <a href="#/contact/view" class="btn btn-simple btn-link btn-wd"><i class="fa fa-times"></i> Cancel</a>
                  <button type="submit" class="btn btn-success btn-wd"><i class="fa fa-save"></i> Save</button>
                </div>
              </div>
          </div>

      </div>
      </form>

      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2020 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>




</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import Vue from 'vue'

import { AddressAutocompleteMixin } from '../../utils/mixins/address-auto-complete.mixin';
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
//auto-complete for contact name
var contactrows = [ ]

//auto-complete for company
var companyrows = [ ]

var error = ''

export default {
  name: 'ContactAdd',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
  },
  mixins: [ AddressAutocompleteMixin ],
  data: function () {
    return {
      errorMessage: error,
      name: '',
      email: '',
      type: 'Person',
      phoneoffice: '',
      phonecell: '',
      fax: '',
      position: '',
      company: '',
      division: '',
      address: '',
      city: '',
      postal: '',
      province: '',
      country: '',
      phone: '',
      website: '',
      formSubmitted: false,
      validate: false,
      companyrows: companyrows,
      contactrows: contactrows
    }
  },
  beforeMount () {
    error = ''
  },
  async mounted(){
    $(document).ready(function() {
      $('input').attr('autocomplete', 'new-password');
    });

    await this.GoogleMapsApi.useAutocomplete('contactAddAddressAutoComplete', (autocomplete) => {
      const fullAddress = this.GoogleMapsApi.getFullAddressString(autocomplete);      
      
      const addressComponents = this.GoogleMapsApi.getAddressComponents(autocomplete);
      console.log("Place Changed addressComponents", addressComponents);
      this.fullAddress = fullAddress;
      this.address = addressComponents.address;
      this.city = addressComponents.city;
      this.province = addressComponents.province;
      this.postal = addressComponents.postal;
      this.country = addressComponents.country;

      const addressCoordinates = this.GoogleMapsApi.getAddressCoordinates(autocomplete);
      this.addressCoordinates = {
        lat: addressCoordinates.lat,
        lng: addressCoordinates.lng,
      }
    });
  },
  beforeDestroy(){
    this.GoogleMapsApi.cleanupAutocomplete('contactAddAddressAutocomplete');
  },
  computed: {
    hasCoordinates() {
      return this.addressCoordinates.lat !== null && this.addressCoordinates.lng !== null;
    }
  },
  methods: {

    onProvinceChange(prov)
    {
      console.log("prov change!");
      if (prov == "AB" || prov == "BC" || prov == "MB" || prov == "NB" || prov == "NF" || prov == "NT" || prov == "NS" || prov == "NU" || prov == "ON" || prov == "PE" || prov == "QC" || prov == "PE" || prov == "QC" || prov == "SK" || prov == "YT")
      {
        this.country = "Canada";
      }
      else
      {
        this.country = "United States";
      }
    },


    validateBeforeSubmit(e) {
      console.log("validateBeforeSubmit()");
      this.validate = true;
      this.$validator.validateAll();
      if (!this.errors.any() && this.hasCoordinates) {
          this.submitForm();
      }
      else {
        console.log("Validation: " + JSON.stringify(this.errors));
      }
    },
    submitForm(){
      this.formSubmitted = true;
      this.addContact();
    },

    contactLiveSearch: function (event) {

      console.log("contactLiveSearch");
      var entry = this.email
      console.log("auto: " + entry);
      if (entry.length < 3) {
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
      } else {

        // Find Matches
        apiService.post('/kong/api/v1/entity/globalemail/', "", { headers: { 'X-Search': entry }}) // this.$cookie.get('apikey')}
        .then(function (response) {

          //disable form
          document.getElementById("name").disabled = true;
          document.getElementById("phoneoffice").disabled = true;
          document.getElementById("phonecell").disabled = true;
          document.getElementById("fax").disabled = true;
          document.getElementById("position").disabled = true;
          document.getElementById("phone").disabled = true;
          document.getElementById("address").disabled = true;
          document.getElementById("contactAddAddressAutoComplete").disabled = true;
          document.getElementById("postal").disabled = true;
          document.getElementById("city").disabled = true;
          document.getElementById("province").disabled = true;
          document.getElementById("country").disabled = true;
          document.getElementById("website").disabled = true;

          // Pop everything off
          var len = contactrows.length;
          for (var j = 0; j < len; j++) {
            contactrows.pop()
          }

          console.log( "results: " + response.data.Result.length );
          contactrows.push({email: "", name: "Add New", id: "-1"})
          for (var i = 0; i < response.data.Result.length; i++) {
            contactrows.push({
            id: response.data.Result[i].id,
            email: response.data.Result[i].email, 
            name: response.data.Result[i].name,
            phoneoffice: response.data.Result[i].phoneoffice,
            phonecell: response.data.Result[i].phonecell,
            fax: response.data.Result[i].fax,
            position: response.data.Result[i].position,
            type: response.data.Result[i].type, 
            phone: response.data.Result[i].phone,
            company: response.data.Result[i].company, 
            division: response.data.Result[i].division, 
            fullAddress: response.data.Result[i].fullAddress, 
            address: response.data.Result[i].address, 
            postal: response.data.Result[i].postal, 
            city: response.data.Result[i].city,
            province: response.data.Result[i].province, 
            country: response.data.Result[i].country,
            addressCoordinates: response.data.Result[i].addressCoordinates,
            website: response.data.Result[i].website, 
            })
          }
          document.getElementById('contactCustomLiveSearch').style.display = 'block'
        })
        .catch(function (error) {
          console.log('contact auto complete error: ' + JSON.stringify(error))
          contactrows.push({email: "", name: "Add New", id: "-1"})
          document.getElementById('contactCustomLiveSearch').style.display = 'block'
        })
        // Sort it all
        contactrows.sort()
      }
    },


    contactSelected: function (row) {

      if (row.id == "-1")
      {
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
        console.log("add new so enable full form");

        document.getElementById("name").removeAttribute("disabled");
        document.getElementById("phoneoffice").removeAttribute("disabled");
        document.getElementById("phonecell").removeAttribute("disabled");
        document.getElementById("fax").removeAttribute("disabled");
        document.getElementById("position").removeAttribute("disabled");
        document.getElementById("company").removeAttribute("disabled");
        document.getElementById("division").removeAttribute("disabled");
        document.getElementById("phone").removeAttribute("disabled");
        document.getElementById("address").removeAttribute("disabled");
        document.getElementById("contactAddAddressAutoComplete").removeAttribute("disabled");
        document.getElementById("postal").removeAttribute("disabled");
        document.getElementById("city").removeAttribute("disabled");
        document.getElementById("province").removeAttribute("disabled");
        document.getElementById("country").removeAttribute("disabled");
        document.getElementById("website").removeAttribute("disabled");

      }
      else
      {
        console.log( JSON.stringify(row) );
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
        this.name = row.name
        this.email = row.email
        this.phoneoffice = row.phoneoffice
        this.phonecell = row.phonecell
        this.fax = row.fax
        this.position = row.position
        this.company = row.company
        this.division = row.division
        this.phone = row.phone
        this.website = row.website
        this.address = row.address
        this.fullAddress = row.fullAddress
        this.postal = row.postal
        this.city = row.city
        this.province = row.province
        this.country = row.country
        this.addressCoordinates = row.addressCoordinates
      }
    },

    companyLiveSearch: function (event) {

      console.log("companyLiveSearch");
      var entry = this.company
      console.log("auto: " + entry);
      if (entry.length < 2) {
        document.getElementById('companyLiveSearch').style.display = 'none'
        this.phone = "";
        this.address = "";
        this.postal = "";
        this.city = "";
        this.province = "";
        this.country = "";
        this.website = "";
        this.division = "";
      } else {

        // Find Matches
        apiService.post('/kong/api/v1/company/globalsearch/', "", { headers: { 'X-Search': entry }})
        .then(function (response) {


          // Pop everything off
          while(companyrows.length > 0) companyrows.pop();

          console.log( "results: " + response.data.Result.length );
          for (var i = 0; i < response.data.Result.length; i++) {
            var companyRow = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              division: response.data.Result[i].division,
              phone: response.data.Result[i].phone, 
              fullAddress: response.data.Result[i].fullAddress, 
              address: response.data.Result[i].address, 
              postal: response.data.Result[i].postal, 
              city: response.data.Result[i].city,
              province: response.data.Result[i].province, 
              country: response.data.Result[i].country,
              addressCoordinates: response.data.Result[i].addressCoordinates,
              website: response.data.Result[i].website,
              display: response.data.Result[i].company
            };

            if (companyRow.division != null && companyRow.division.length > 0) companyRow.display += " - " + companyRow.division;
            companyrows.push(companyRow);
          }
          document.getElementById('companyLiveSearch').style.display = 'block'
        })
        .catch(function (error) {
          console.log('company auto complete error: ' + JSON.stringify(error))
          while(companyrows.length > 0) companyrows.pop();
          document.getElementById('companyLiveSearch').style.display = 'block'
        })
        // Sort it all
        companyrows.sort()

        //they are typing a new company, enable form
        document.getElementById("phone").removeAttribute("disabled");
        document.getElementById("address").removeAttribute("disabled");
        document.getElementById("contactAddAddressAutoComplete").removeAttribute("disabled");
        document.getElementById("postal").removeAttribute("disabled");
        document.getElementById("city").removeAttribute("disabled");
        document.getElementById("province").removeAttribute("disabled");
        document.getElementById("country").removeAttribute("disabled");
        document.getElementById("website").removeAttribute("disabled");
      }
    },

    companySelected: function (row) {
      console.log("-----------companySelected");
      console.log( JSON.stringify(row) );
      document.getElementById('companyLiveSearch').style.display = 'none'
      this.website = row.website
      this.phone = row.phone
      this.fullAddress = row.fullAddress
      this.address = row.address
      this.postal = row.postal
      this.city = row.city
      this.province = row.province
      this.country = row.country
      this.company = row.company
      this.addressCoordinates = row.addressCoordinates
      this.division = row.division

      //disable lower part of form when existing company selected
      document.getElementById("website").disabled = true;
      document.getElementById("phone").disabled = true;
      document.getElementById("address").disabled = true;
      document.getElementById("contactAddAddressAutoComplete").disabled = true;
      document.getElementById("postal").disabled = true;
      document.getElementById("city").disabled = true;
      document.getElementById("province").disabled = true;
      document.getElementById("country").disabled = true;
    },

    divisionChange: function() {
      document.getElementById('companyLiveSearch').style.display = 'none'

      //they are typing a new division, enable form and clear address fields
      document.getElementById("website").removeAttribute("disabled");
      document.getElementById("phone").removeAttribute("disabled");
      document.getElementById("address").removeAttribute("disabled");
      document.getElementById("contactAddAddressAutoComplete").removeAttribute("disabled");
      document.getElementById("postal").removeAttribute("disabled");
      document.getElementById("city").removeAttribute("disabled");
      document.getElementById("province").removeAttribute("disabled");
      document.getElementById("country").removeAttribute("disabled");

      this.website = "";
      this.phone = "";
      this.address = "";
      this.postal = "";
      this.city = "";
      this.province = "";
      this.country = "";

    },



    addContact: function (event) {
      var passed_email = this.email

      // Sent API request
      apiService.post('/kong/api/v1/entity/', {
        name: this.name,
        email: this.email,
        phoneoffice: this.phoneoffice,
        phonecell: this.phonecell,
        fax: this.fax,
        position: this.position,
        type: this.type,
        website: this.website,
        phone: this.phone,
        fullAddress: this.fullAddress,
        address: this.address,
        postal: this.postal,
        city: this.city,
        province: this.province,
        country: this.country,
        addressCoordinates: this.addressCoordinates,
        company: this.company,
        division: this.division })
      .then(function (response) {
        // If successful add the relationship
        apiService.put('/kong/api/v1/entity/relationship/', {
          email: passed_email })
        .then(function (response) {
          // If successful notify the user and segue to contacts view
          router.push('/contact/view')
          Vue.toasted.success("Successfully Added Contact", { duration: 3500 })
        })
        .catch(function (error) {
          // Otherwise inform them of the issue
          Vue.toasted.error(error.response.data.Result, { duration: 3500 })
        })
      })
      .catch(function (error) {
        // Link a contact if they already exist in the database
        if (error.response.data.Result == "Sorry, the user already exists") {
          apiService.put('/kong/api/v1/entity/relationship/', {
            email: passed_email })
          .then(function (response) {
            Vue.toasted.success("Successfully Linked Contact", { duration: 3500 })
            router.push('/contact/view')
          })
          .catch(function (error) {
            Vue.toasted.error(error.response.data.Result, { duration: 3500 })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?0363a97f